import React, { useState } from "react";

const CustomSwitch = ({ label, onChange, state: controlledState }) => {
  const isControlled = controlledState !== undefined;
  const [internalState, setInternalState] = useState(null); // null (Grey), true (Yes), false (No)
  const state = isControlled ? controlledState : internalState;

  const handleToggle = () => {
    const newState = state === null ? true : state ? false : null; // Alterna entre Yes -> No -> Grey
    if (!isControlled) {
      setInternalState(newState);
    }
    onChange(newState); // Notifica al padre el cambio
  };

  return (
    <div className="flex items-center space-x-2">
      <button
        type="button"
        onClick={handleToggle}
        className={`w-10 h-6 flex items-center rounded-full p-1 transition-colors duration-300 ${
          state === true
            ? "bg-green-500"
            : state === false
            ? "bg-red-500"
            : "bg-yellow-500"
        }`}
      >
        <span
          className={`w-4 h-4 bg-white rounded-full transform transition-transform duration-300 ${
            state === true ? "translate-x-4" : state === false ? "translate-x-2" : ""
          }`}
        ></span>
      </button>
      <span
        className={`font-bold ${
          state === true
            ? "text-green-600"
            : state === false
            ? "text-red-600"
            : "text-black-500"
        }`}
      >
        {state === true ? "Sí" : state === false ? "No" : "Neutral"}
      </span>
      <span className="text-sm text-black-500">{label}</span>
    </div>
  );
};

export default CustomSwitch;
